import { defineMessages } from 'react-intl';

export default defineMessages({
  delivery: {
    id: 'app.orderStatus.containers.DeliveryPartnerInfo.delivery',
    defaultMessage: 'ENVÍO DEL LOCAL',
  },
  pickup: {
    id: 'app.orderStatus.containers.DeliveryPartnerInfo.pickup',
    defaultMessage: 'SIN COSTO DE ENVÍO',
  },
  logistics: {
    id: 'app.orderStatus.containers.DeliveryPartnerInfo.logistics',
    defaultMessage: 'ENTREGA',
  },
  onlyWeekly: {
    id: 'app.shopDetails.components.DeliveryPartnerInfo.onlyWeekly',
    defaultMessage: '{value}% OFF',
  },
  onlyPickup: {
    id: 'app.shopDetails.components.DeliveryPartnerInfo.onlyPickup',
    defaultMessage: '{value}% OFF',
  },
  pickupAndWeekly: {
    id: 'app.shopDetails.components.DeliveryPartnerInfo.pickupAndWeekly',
    defaultMessage: 'HASTA {value}% OFF',
  },
});
